export const INSURER_MIN_AGE = 16;
export const DATE_OF_BIRTH_MAX_AGE = 105;
export const EMAIL_MAX_LENGTH = 50;
export const NAME_MIN_LENGTH = 2;
export const NAME_MAX_LENGTH = 50;
export const PASSWORD_MIN_LENGTH = 6;
export const PASSWORD_MAX_LENGTH = 20;

export const SEOPA_LTD_ADDRESS = 'Floor 4, Blackstaff Studios, 8-10 Amelia Street, Belfast, Northern Ireland, BT2 7GS';

export const DEFAULT_PARTNER = 'newQuotezoneResponsive';
export const DEFAULT_PARTNER_ALTERNATIVE = 'quotezonenew';
export const CNI_PARTNER = 'newCniwlResponsive';
export const CNI_PARTNER_ALTERNATIVE = 'cniwl';
export const CNI_PARTNER_TEST = '29313aefb13facf01fbfa8b0c714f19c';

export const PARTNERS = {
  CompareNI: [CNI_PARTNER_TEST, CNI_PARTNER, CNI_PARTNER_ALTERNATIVE],
  QuoteZone: [DEFAULT_PARTNER, DEFAULT_PARTNER_ALTERNATIVE],
};

// Login error codes
export const BIRTH_DATE_REQUIRED_CODE = 'bD_03';
export const FIRST_NAME_REQUIRED_CODE = 'fN_03';
export const LAST_NAME_REQUIRED_CODE = 'lN_03';

export const EMAIL_REGEX = /^(?!(?:(?:\x22?\x5C[\x00-\x7E]\x22?)|(?:\x22?[^\x5C\x22]\x22?)){255,})(?!(?:(?:\x22?\x5C[\x00-\x7E]\x22?)|(?:\x22?[^\x5C\x22]\x22?)){65,}@)(?:(?:[\x21\x23-\x27\x2A\x2B\x2D\x2F-\x39\x3D\x3F\x5E-\x7E]+)|(?:\x22(?:[\x01-\x08\x0B\x0C\x0E-\x1F\x21\x23-\x5B\x5D-\x7F]|(?:\x5C[\x00-\x7F]))*\x22))(?:\.(?:(?:[\x21\x23-\x27\x2A\x2B\x2D\x2F-\x39\x3D\x3F\x5E-\x7E]+)|(?:\x22(?:[\x01-\x08\x0B\x0C\x0E-\x1F\x21\x23-\x5B\x5D-\x7F]|(?:\x5C[\x00-\x7F]))*\x22)))*@(?:(?:(?!.*[^.]{64,})(?:(?:(?:xn--)?[a-z0-9]+(?:-+[a-z0-9]+)*\.){1,126}){1,}(?:(?:[a-z][a-z0-9]*)|(?:(?:xn--)[a-z0-9]+))(?:-+[a-z0-9]+)*)|(?:\[(?:(?:IPv6:(?:(?:[a-f0-9]{1,4}(?::[a-f0-9]{1,4}){7})|(?:(?!(?:.*[a-f0-9][:\]]){7,})(?:[a-f0-9]{1,4}(?::[a-f0-9]{1,4}){0,5})?::(?:[a-f0-9]{1,4}(?::[a-f0-9]{1,4}){0,5})?)))|(?:(?:IPv6:(?:(?:[a-f0-9]{1,4}(?::[a-f0-9]{1,4}){5}:)|(?:(?!(?:.*[a-f0-9]:){5,})(?:[a-f0-9]{1,4}(?::[a-f0-9]{1,4}){0,3})?::(?:[a-f0-9]{1,4}(?::[a-f0-9]{1,4}){0,3}:)?)))?(?:(?:25[0-5])|(?:2[0-4][0-9])|(?:1[0-9]{2})|(?:[1-9]?[0-9]))(?:\.(?:(?:25[0-5])|(?:2[0-4][0-9])|(?:1[0-9]{2})|(?:[1-9]?[0-9]))){3}))\]))$/i;
export const NAME_REGEX = /^([A-Za-z-\s']|[À-Ö]|[Ø-ö]|[ø-ǿ]|[Ȁ-ʯ]|[̀-ͯ]|[Ḁ-ỿ]|[Ⅰ-ↈ])+$/i;
export const NUMBERS_REGEX = /^[0-9]*$/;
export const PASSWORD_REGEX = /^[^\s].*[^\s]$/;

export const QZ_SITE_BASE_URL = 'https://www.quotezone.co.uk';
export const CNI_SITE_BASE_URL = 'https://www.compareni.com';

export const EMAIL_RULES = [
  v => !!v || 'Please enter a valid email address.',
  v => v.length <= EMAIL_MAX_LENGTH || `Email must be less than ${EMAIL_MAX_LENGTH} characters long`,
  v => EMAIL_REGEX.test(v) || 'Please enter a valid email address.',
];

export const FIRST_NAME_RULES = [
  v => !!v || 'Please enter your First name.',
  v => NAME_REGEX.test(v) || 'Please enter a valid First name. It may contain letters, spaces and hyphen.',
  v => v.length >= NAME_MIN_LENGTH || `First name must contain at least ${NAME_MIN_LENGTH} characters.`,
  v => v.length <= NAME_MAX_LENGTH || `First name must contain less than ${NAME_MAX_LENGTH} characters.`,
];

export const LAST_NAME_RULES = [
  v => !!v || 'Please enter your Last name.',
  v => NAME_REGEX.test(v) || 'Please enter a valid Last name. It may contain letters, spaces and hyphen.',
  v => v.length >= NAME_MIN_LENGTH || `Last name must contain at least ${NAME_MIN_LENGTH} characters.`,
  v => v.length <= NAME_MAX_LENGTH || `Last name must contain less than ${NAME_MAX_LENGTH} characters.`,
];

export const PASSWORD_RULES = [
  v => !!v || 'Please enter your password.',
];

export const NEW_PASSWORD_RULES = [
  v => !!v || 'Please enter new password',
  v => (PASSWORD_REGEX.test(v) && v.length >= PASSWORD_MIN_LENGTH && v.length <= PASSWORD_MAX_LENGTH) ||
    `Password length must be between ${PASSWORD_MIN_LENGTH} and ${PASSWORD_MAX_LENGTH} characters and must not contain spaces at the beginning or end.`,
];

export const COMPLETE_DOB_ERROR_MESSAGE = 'Please complete your date of birth.';
export const FORM_NOT_VALID_ERROR_MESSAGE = 'Please fill in the form correctly';
export const NO_QUOTES_TEXT = 'No quotes';

export const DEFAULT_WL_CONFIG = {
  marketingOptions: null,
  brandingType: 'Quotezone',
};

export const MODAL_CONTENT = {
  409: {
    title: 'We\'re sorry, we\'re unable to find your session.',
    mainText: 'This may be as a result of your cookies, or beginning a session on more than one insurance product.\n' +
      'To continue, please click the link below',
    btnLabel: 'Click here to login',
  },
  440: {
    title: 'We\'re sorry, we\'re unable to find your session.',
    mainText: 'This may be because of your session timing out, or your browser cookies being disabled.\n' +
      'To continue, please click the link below',
    btnLabel: 'Click here to login',
  },
};
